import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { key: 1 }

import { computed, toRefs } from 'vue';
import { createListSummary } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  props: {
    array: null,
    fn: null,
    max: { default: 3 },
    classValue: null,
    classMore: { default: 'text-xs font-medium border rounded px-2 py-0.5 ml-2 text-gray-500' }
  },
  setup(__props: any) {

const props = __props as { array: unknown[], fn:(t: unknown) => string, max: number, classValue?: string, classMore: string }



const {
  array, fn, max, classValue, classMore,
} = toRefs(props);
const listSummary = computed(() => createListSummary(array.value, fn.value, max.value));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listSummary).values, (value, index) => {
      return (_openBlock(), _createElementBlock("span", {
        key: index,
        class: _normalizeClass([_unref(classValue)]),
        textContent: _toDisplayString(`${value}${_unref(listSummary).values.length - 1 === index ? '' : ', '} `)
      }, null, 10, _hoisted_1))
    }), 128)),
    (_unref(listSummary).hasMore)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass([_unref(classMore)]),
          textContent: _toDisplayString(`+${_unref(listSummary).rest}`)
        }, null, 10, _hoisted_2))
      : _createCommentVNode("", true),
    (_unref(listSummary).total === 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, " — "))
      : _createCommentVNode("", true)
  ]))
}
}

})